module.exports = __webpack_public_path__ + "static/media/smile.ddde1b44.svg";